export default '__carry_over__';

//# sourceMappingURL=carryOverIdentificator.js.map